<template>
    <div>
        <div class="page-section">
            <a-card :bordered="false" style="width: 100%" id="title-card">
                <template slot="title">
                    <div class="v2-tab-hd">
                        <h2>Meus Produtos</h2>
                        <div class="v2-tab-sub">Produtos do seu catálogo</div>
                    </div>
                </template>
                <template slot="extra">
                    <div class="title-actions">
                        <a-button v-if="can('PRODUCT', 'UPDATE')" type="default" @click="openAddProduct">
                            <i class="fa-solid fa-plus"></i> Adicionar Produtos
                        </a-button>
                        <a-dropdown :trigger="['click']">
                            <a-button type="default">
                                <i class="fa-solid fa-ellipsis-vertical"></i> Outras Funções <a-icon type="down" />
                            </a-button>
                            <a-menu slot="overlay" @click="handleOtherFunction">
                                <a-menu-item key="print"><i class="fa-solid fa-print"></i> Imprimir</a-menu-item>
                                <a-menu-item key="excel"><i class="fa-solid fa-file-excel"></i> Excel</a-menu-item>
                                <a-menu-item key="groups"><i class="fa-solid fa-layer-group"></i> Grupo de Produtos</a-menu-item>
                                <a-menu-item key="categories"><i class="fa-solid fa-tags"></i> Categorias</a-menu-item>
                                <a-menu-item v-if="hasVfIntegration" key="import">
                                    <i class="fa-solid fa-file-import"></i> Importar produtos
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-button type="default" :hidden="!isDesktop" @click="showTotalizadores = !showTotalizadores">
                            <i class="fa-solid fa-calculator"></i>
                            {{ showTotalizadores ? "Ocultar Totalizadores" : "Mostrar Totalizadores" }}
                        </a-button>
                        <a-button type="danger" :hidden="!isDesktop" @click="handleLimparFiltros">
                            <i class="fa-solid fa-filter-circle-xmark"></i> Limpar Filtros
                        </a-button>
                        <a-button type="primary" @click="drawerVisible = true">
                            <i class="fa-solid fa-filter"></i> Mais Filtros
                        </a-button>
                    </div>
                </template>

                <a-form layout="vertical" style="width: 100%" @submit.prevent="filtrar">
                    <a-row :gutter="[12, 12]">
                        <a-col :xs="24" :sm="12" :md="8" :lg="6">
                            <a-input
                                v-model="filters.search"
                                placeholder="Buscar por nome ou código"
                                allowClear
                                @pressEnter="filtrar"
                            />
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8" :lg="5">
                            <a-select
                                v-model="filters.categoria"
                                show-search
                                allowClear
                                placeholder="Categoria"
                                style="width: 100%"
                                :options="categoryOptions"
                                :filterOption="filterOption"
                                :dropdown-style="{ minWidth: '250px' }"
                            />
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8" :lg="5">
                            <a-select
                                v-model="filters.grupo"
                                show-search
                                allowClear
                                placeholder="Grupo"
                                style="width: 100%"
                                :options="groupOptions"
                                :filterOption="filterOption"
                                :dropdown-style="{ minWidth: '250px' }"
                            />
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8" :lg="3">
                            <a-select
                                v-model="filters.status"
                                placeholder="Situação"
                                style="width: 100%"
                                :options="situationOptions"
                            />
                        </a-col>
                        <a-col flex="auto" class="actions-col">
                            <a-form-item class="item-button">
                                <div class="actions-right">
                                    <a-button type="default" icon="search" @click="filtrar">Filtrar</a-button>
                                </div>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>

                <AdvancedFiltersDrawer :visible.sync="drawerVisible" @apply="filtrar" @clear="handleLimparFiltros">
                    <a-row :gutter="16">
                        <a-col :xs="24" :md="12">
                            <a-form-item label="Buscar por nome">
                                <a-input
                                    v-model="filters.search"
                                    placeholder="Descrição ou código"
                                    allowClear
                                    @pressEnter="filtrar"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :md="12">
                            <a-form-item label="Categoria">
                                <a-select
                                    v-model="filters.categoria"
                                    show-search
                                    allowClear
                                    placeholder="Selecione a categoria"
                                    :options="categoryOptions"
                                    :filterOption="filterOption"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :md="12">
                            <a-form-item label="Grupo">
                                <a-select
                                    v-model="filters.grupo"
                                    show-search
                                    allowClear
                                    placeholder="Selecione o grupo"
                                    :options="groupOptions"
                                    :filterOption="filterOption"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :md="12">
                            <a-form-item label="Situação">
                                <a-select
                                    v-model="filters.status"
                                    placeholder="Situação"
                                    :options="situationOptions"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </AdvancedFiltersDrawer>
            </a-card>
        </div>

        <div v-if="isDesktop" class="page-section">
            <dashboard-stats
                :items="dashboardCards"
                :showTotalizadores="showTotalizadores"
                :selectedKeys="selectedCardKeys"
                dynamic-width
                @click="aplicarFiltroRapido"
            />
        </div>

        <div class="page-section">
            <a-card
                :bordered="false"
                style="width: 100%"
                class="table-card"
                :style="selectedRowKeys.length && { marginBottom: '60px' }"
            >
                <div class="table-container">
                    <a-table
                        size="small"
                        :columns="columns"
                        :data-source="products"
                        :row-key="getRowKey"
                        :loading="loading"
                        :pagination="pagination"
                        :scroll="{ x: 'max-content' }"
                        :row-selection="rowSelection"
                        :expandIcon="renderExpandIcon"
                        :expandedRowKeys="expandedRowKeys"
                        :locale="{ emptyText: 'Nenhum produto encontrado' }"
                        @expandedRowsChange="(keys) => (expandedRowKeys = keys)"
                        @change="handleTableChange"
                    >
                        <template slot="embalagem" slot-scope="text, record">
                            {{ getEmbalagem(record) }}
                        </template>
                        <template slot="ultimoPreco" slot-scope="text, record">
                            <span class="money-cell">{{ getUltimoPreco(record) | currency }}</span>
                        </template>
                        <template slot="date" slot-scope="text">
                            {{ formatDate(text) }}
                        </template>
                        <template slot="lastPurchase" slot-scope="text, record">
                        {{ formatDate(lastPurchaseDate(record)) }}
                    </template>
                    <template slot="acoes" slot-scope="text, record">
                            <ActionMenu :actions="getActions(record)" />
                        </template>

                        <div slot="expandedRowRender" slot-scope="record" class="expanded-content">
                            <a-table
                                size="small"
                                :columns="purchaseColumns"
                                :data-source="purchaseLines(record)"
                                :row-key="(line, index) => index"
                                :pagination="false"
                            >
                                <template slot="date" slot-scope="text">
                                    {{ formatDate(text) }}
                                </template>
                                <template slot="cotacao" slot-scope="text, line">
                                    <a @click="openRequestDetails(record, line)">{{ text }}</a>
                                </template>
                                <template slot="lineEmbalagem" slot-scope="text, line">
                                    {{ record.pro_generico == 0 ? line.item_embalagem : record.pro_unidade_compra }}
                                </template>
                                <template slot="money" slot-scope="text">
                                    <span class="money-cell">{{ text | currency }}</span>
                                </template>
                                <template slot="lineTotal" slot-scope="text, line">
                                    <span class="money-cell">{{ getTotal(line, record) | currency }}</span>
                                </template>
                            </a-table>
                        </div>
                    </a-table>
                </div>
            </a-card>
        </div>

        <SelectionFooter :count="selectedRowKeys.length" itemLabel="produto(s) selecionado(s)">
            <template slot="actions">
                <a-button @click="addSelectedToGroup">
                    <i class="fa-solid fa-layer-group"></i> Adicionar ao grupo
                </a-button>
                <a-button @click="clearSelection">
                    <i class="fa-solid fa-xmark"></i> Limpar seleção
                </a-button>
            </template>
        </SelectionFooter>

        <div hidden>
            <div id="products-v2-print">
                <div class="row" style="width: 100%">
                    <div style="display: flex; gap: 40px; align-items: center">
                        <img
                            class="logo"
                            :src="whitelabel ? whitelabel.data.imgs.img_logo : require('@/assets/Logo-BRANCA.svg')"
                        />
                        <div>Meus Produtos</div>
                        <div>Usuário: {{ user.user_name }}</div>
                        <div>Empresa: {{ user.group }}</div>
                    </div>
                    <div style="margin-top: 1vh">Data: {{ printDate }}</div>
                </div>
                <div class="table">
                    <div style="border-bottom: 1px solid gray" class="print-table-row">
                        <div class="print-table-desc">Descrição</div>
                        <div style="width: 10vw; text-align: center">Estoque/Pedido</div>
                        <div style="width: 10vw; text-align: center">Estoque/Pedido</div>
                        <div style="width: 10vw; text-align: center">Estoque/Pedido</div>
                        <div style="width: 10vw; text-align: center">Estoque/Pedido</div>
                    </div>
                    <div style="border-bottom: 1px solid gray" v-for="(item, index) in printProducts" :key="index">
                        <div class="print-table-row">
                            <div class="print-table-desc">{{ item.pro_descricao }}</div>
                            <div v-for="n in 8" :key="n" style="width: 5vw; border-left: 0.1vw solid gray"></div>
                        </div>
                        <div class="print-table-row">
                            <div class="print-table-ean">EAN: {{ item.pro_ean }}</div>
                            <div class="print-table-eamb">Embalagem: {{ getEmbalagem(item) }}</div>
                            <div class="print-table-cat">Categoria: {{ item.cat_descricao }}</div>
                            <div class="print-table-est">Generico: {{ item.pro_generico ? "sim" : "não" }}</div>
                            <div v-for="n in 8" :key="n" style="width: 5vw; border-left: 0.1vw solid gray"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <cc-loader-full v-if="loadingFull" />
        <AddToGroupV2Modal v-if="addProduct" :product="addProduct" @updated="loadGroups" @close="addProduct = undefined" />
        <ProductGroupsV2Modal v-if="showManagementProducts" @updated="loadGroups" @close="showManagementProducts = false" />
        <CategoriesV2Modal v-if="showCategories" @updated="loadCategories" @close="showCategories = false" />
        <AddProductV2Modal v-if="showAddProduct" @add_product="loadProducts(1)" @close="showAddProduct = false" />
        <RequestDetailsV2Modal
            v-if="requestDetails"
            :product="requestDetails.product"
            :product_id="requestDetails.line.pro_id"
            :seller_id="requestDetails.line.id_vendedor"
            :price="requestDetails.line.valor_unitario"
            :request_id="requestDetails.line.numero_cotacao"
            @close="requestDetails = null"
        />
    </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { typingRemoteRequestControlMixin } from "@/mixins/typing-remote-request-controls.mixin";
import { perm_mixin } from "@/mixins/permission.mixin";
import * as CONSTANTS from "@/constants/constants";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import StorageService from "@/services/local-storage.service";
import VarejoFacilService from "@/services/VarejoFacilService";
import ProductsV3Service from "@/services/v3/products/product.service";
import ProductGroupService from "@/services/v3/management/ProductGroupService.js";
import MyProductsExcelDownload from "@/services/MyProductsExcelDownload.js";
import StatsCards from "@/components/cliente/monitors/StatsCards.vue";
import AdvancedFiltersDrawer from "@/components/cliente/monitors/AdvancedFiltersDrawer.vue";
import SelectionFooter from "@/components/cliente/monitors/SelectionFooter.vue";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import AddProductV2Modal from "../modals/add-product-v2.modal.vue";
import CategoriesV2Modal from "../modals/categories-v2.modal.vue";
import RequestDetailsV2Modal from "../modals/request-details-v2.modal.vue";
import ProductGroupsV2Modal from "../modals/product-groups-v2.modal.vue";
import AddToGroupV2Modal from "../modals/add-to-group-v2.modal.vue";

const PAGE_SIZE = 30;
const EXPORT_PAGE_SIZE = 100000;

const emptyFilters = () => ({
    search: "",
    categoria: undefined,
    grupo: undefined,
    status: "1",
});

export default {
    name: "MyProductsV2Tab",
    mixins: [typingRemoteRequestControlMixin, perm_mixin, loaderMixin],
    components: {
        "dashboard-stats": StatsCards,
        AdvancedFiltersDrawer,
        SelectionFooter,
        ActionMenu,
        AddProductV2Modal,
        CategoriesV2Modal,
        RequestDetailsV2Modal,
        ProductGroupsV2Modal,
        AddToGroupV2Modal,
    },
    data() {
        return {
            products_v3_service: new ProductsV3Service(),
            vf_svc: new VarejoFacilService(),
            groupService: new ProductGroupService(),
            isDesktop: window.innerWidth >= 720,
            showTotalizadores: true,
            drawerVisible: false,
            loading: false,
            loadingFull: false,
            filters: emptyFilters(),
            productsType: "all",
            sortOrder: undefined,
            products: [],
            expandedRowKeys: [],
            selectedRowKeys: [],
            selectedRows: [],
            countAll: 0,
            countBuy: 0,
            countNever: 0,
            arrayCategoria: [],
            groups: [],
            printProducts: [],
            printDate: "",
            pagination: {
                current: 1,
                pageSize: PAGE_SIZE,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ["30", "50", "100"],
                locale: { items_per_page: "/ página" },
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
            requestDetails: null,
            addProduct: undefined,
            showAddProduct: false,
            showCategories: false,
            showManagementProducts: false,
            purchaseColumns: [
                { title: "Fornecedor", dataIndex: "fornecedor", key: "fornecedor" },
                { title: "Marca", dataIndex: "marca", key: "marca" },
                { title: "Data Compra", dataIndex: "data_compra", key: "data_compra", align: "center", scopedSlots: { customRender: "date" } },
                { title: "Número Cotação", dataIndex: "numero_cotacao", key: "numero_cotacao", align: "center", scopedSlots: { customRender: "cotacao" } },
                { title: "N. Requisitantes", dataIndex: "numero_requisitante", key: "numero_requisitante", align: "center" },
                { title: "Quantidade", dataIndex: "quantidade", key: "quantidade", align: "center" },
                { title: "Embalagem", key: "embalagem", align: "center", scopedSlots: { customRender: "lineEmbalagem" } },
                { title: "Valor Unit", dataIndex: "valor_unitario", key: "valor_unitario", align: "right", scopedSlots: { customRender: "money" } },
                { title: "Valor Total", key: "valor_total", align: "right", scopedSlots: { customRender: "lineTotal" } },
            ],
        };
    },
    watch: {
        countAll(value) {
            this.$emit("count", value);
        },
    },
    computed: {
        ...mapState(["user", "whitelabel"]),
        ...mapGetters({ setting: "user/setting" }),
        hasVfIntegration() {
            return !!StorageService.get_string("has_vf_integration");
        },
        situationOptions() {
            return [
                { value: "1", label: "Itens ativos" },
                { value: "0", label: "Itens inativos" },
            ];
        },
        categoryOptions() {
            return this.arrayCategoria.map((c) => ({ value: c.cat_id, label: c.cat_descricao }));
        },
        groupOptions() {
            return this.groups.map((g) => ({ value: g.id, label: g.descricao }));
        },
        selectedCardKeys() {
            return this.productsType === "all" ? [] : [this.productsType];
        },
        dashboardCards() {
            return [
                {
                    key: "all",
                    title: "Todos",
                    icon: "inventory_2",
                    value: this.countAll,
                    borderColor: "#1890ff",
                },
                {
                    key: "buy",
                    title: "Apenas comprados",
                    icon: "shopping_cart_checkout",
                    value: this.countBuy,
                    borderColor: "#52c41a",
                    suffix: `(${this.percentOf(this.countBuy)}%)`,
                },
                {
                    key: "empty",
                    title: "Não comprados",
                    icon: "remove_shopping_cart",
                    value: this.countNever,
                    valueColor: "#fa8c16",
                    borderColor: "#fa8c16",
                    suffix: `(${this.percentOf(this.countNever)}%)`,
                },
            ];
        },
        columns() {
            return [
                { title: "Código", dataIndex: "pro_ean", key: "pro_ean" },
                { title: "Descrição", dataIndex: "pro_descricao", key: "pro_descricao" },
                { title: "Embalagem", key: "embalagem", align: "center", scopedSlots: { customRender: "embalagem" } },
                { title: "Último Preço", key: "ultimo_preco", align: "right", scopedSlots: { customRender: "ultimoPreco" } },
                { title: "Data cadastro", dataIndex: "pro_dataCadastro", key: "pro_dataCadastro", align: "center", scopedSlots: { customRender: "date" } },
                {
                    title: "Data Últ. Compra",
                    dataIndex: "pro_dataÚltimaCompra",
                    key: "pro_dataÚltimaCompra",
                    align: "center",
                    sorter: true,
                    sortDirections: ["ascend", "descend"],
                    sortOrder: this.sortOrder === "asc" ? "ascend" : this.sortOrder === "desc" ? "descend" : false,
                    scopedSlots: { customRender: "lastPurchase" },
                },
                { title: "Ações", key: "acoes", align: "center", width: 70, scopedSlots: { customRender: "acoes" } },
            ];
        },
        rowSelection() {
            if (!this.can("PRODUCT", "UPDATE")) return null;
            return {
                selectedRowKeys: this.selectedRowKeys,
                onChange: (keys, rows) => {
                    this.selectedRowKeys = keys;
                    this.selectedRows = rows;
                },
            };
        },
    },
    methods: {
        getRowKey(record) {
            return record.pro_id;
        },
        filterOption(input, option) {
            const label = option.componentOptions.children[0].text || "";
            return label.toLowerCase().includes(input.toLowerCase());
        },
        percentOf(value) {
            if (!this.countAll) return "0,00";
            return ((value / this.countAll) * 100).toFixed(2).replace(".", ",");
        },
        formatDate(value) {
            return value ? moment(value).format("DD/MM/YYYY") : "--";
        },
        getEmbalagem(product) {
            return product.pro_generico == 1 ? product.pro_unidade_compra : product.pro_embalagem;
        },
        getUltimoPreco(product) {
            if (product.info_adicional && product.info_adicional.length) return product.info_adicional[0].valor_unitario;
            return product.pro_ultimaCompra || 0;
        },
        purchaseLines(product) {
            return product.info_adicional || [];
        },
        lastPurchaseDate(product) {
            const history = this.purchaseLines(product);
            return history.length ? history[0].data_compra : product.pro_dataÚltimaCompra;
        },
        getTotal(line, product) {
            if (product.pro_generico == 0) {
                const quantity = parseFloat(String(line.item_embalagem || "").split(" ")[1]);
                if (!isNaN(quantity)) return line.valor_unitario * quantity * line.quantidade;
            }
            return line.valor_total;
        },
        renderExpandIcon({ record, expanded, onExpand }) {
            const h = this.$createElement;
            if (!this.purchaseLines(record).length) return h("span");
            return h("a-icon", {
                class: "row-icon",
                attrs: { title: expanded ? "Esconder histórico de compras" : "Ver histórico de compras" },
                props: { type: expanded ? "minus-square" : "plus-square" },
                on: { click: (e) => onExpand(record, e) },
            });
        },
        buildFilterParams() {
            const params = {};
            const { search, categoria, grupo, status } = this.filters;
            if (search && search.trim()) params["filter[search]"] = search.trim();
            if (categoria) params["filter[categoria]"] = categoria;
            if (grupo) params["filter[grupo]"] = grupo;
            if (status !== undefined && status !== null) params["filter[status]"] = status;
            if (this.productsType === "buy") params["filter[comprado]"] = 1;
            else if (this.productsType === "empty") params["filter[comprado]"] = 0;
            return params;
        },
        buildSort() {
            if (this.sortOrder === "asc") return "pro_dataÚltimaCompra";
            if (this.sortOrder === "desc") return "-pro_dataÚltimaCompra";
            return undefined;
        },
        resetTableState() {
            this.expandedRowKeys = [];
            this.clearSelection();
        },
        loadProducts(page = this.pagination.current) {
            this.loading = true;
            this.cancelSearch();
            const token = this.cancelSource.token;
            const filters = this.buildFilterParams();
            this.resetTableState();
            this.products_v3_service
                .query(
                    {
                        ...filters,
                        page,
                        per_page: this.pagination.pageSize,
                        sort: this.buildSort(),
                        with_purchase_history: 1,
                    },
                    token
                )
                .then(({ data }) => {
                    this.products = data.data || [];
                    this.pagination.current = data.meta ? data.meta.current_page : page;
                    this.pagination.total = data.meta ? data.meta.total : this.products.length;
                    this.loading = false;
                })
                .catch((error) => {
                    if (axios.isCancel(error)) return;
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
            this.products_v3_service
                .summary(filters, token)
                .then(({ data }) => {
                    this.countAll = data.total_produtos;
                    this.countBuy = data.comprados;
                    this.countNever = data.nunca_comprados;
                })
                .catch(() => {});
        },
        filtrar() {
            this.loadProducts(1);
        },
        handleLimparFiltros() {
            this.filters = emptyFilters();
            this.productsType = "all";
            this.sortOrder = undefined;
            this.loadProducts(1);
        },
        aplicarFiltroRapido(key) {
            this.productsType = key === this.productsType ? "all" : key;
            this.loadProducts(1);
        },
        handleTableChange(pagination, filters, sorter) {
            const order = sorter && sorter.order ? (sorter.order === "ascend" ? "asc" : "desc") : undefined;
            const sizeChanged = pagination.pageSize !== this.pagination.pageSize;
            this.pagination.pageSize = pagination.pageSize;
            if (order !== this.sortOrder || sizeChanged) {
                this.sortOrder = order;
                this.loadProducts(1);
                return;
            }
            this.loadProducts(pagination.current);
        },
        clearSelection() {
            this.selectedRowKeys = [];
            this.selectedRows = [];
        },
        addSelectedToGroup() {
            if (!this.selectedRows.length) return;
            this.addProduct = [...this.selectedRows];
            this.clearSelection();
        },
        getActions(product) {
            const canUpdate = this.can("PRODUCT", "UPDATE");
            const canDelete = this.can("PRODUCT", "DELETE");
            return [
                { label: "Editar produto", icon: "edit", iconClass: "action-info", visible: canUpdate, onClick: () => this.openProduct(product, "DATA") },
                { label: "Histórico de alterações", icon: "format_list_bulleted", iconClass: "action-primary", onClick: () => this.openProduct(product, "LOG") },
                { label: "Histórico do produto", icon: "inventory", iconClass: "action-teal", onClick: () => this.openProduct(product, "HISTORY") },
                { label: "Adicionar a um grupo", icon: "playlist_add", iconClass: "action-success", visible: canUpdate, onClick: () => this.openProduct(product, "GROUPS") },
                { label: "Ver marcas", icon: "category", iconClass: "action-warning", visible: product.pro_generico != 0, onClick: () => this.openProduct(product, "BRANDS") },
                { divider: true, visible: canDelete },
                { label: "Excluir produto", icon: "delete", iconClass: "action-danger", visible: canDelete, onClick: () => this.deleteProduct(product) },
            ];
        },
        openAddProduct() {
            this.showAddProduct = true;
        },
        openProduct(product, tab) {
            this.$router.push({
                name: "products-v2-product",
                params: { productId: product.pro_id, product },
                query: { tab },
            });
        },
        openRequestDetails(product, line) {
            this.requestDetails = { product, line };
        },
        deleteProduct(product) {
            this.$swal
                .fire({
                    title: "Confirma a exclusão do produto?",
                    text: "Seu produto será excluído!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim!",
                    cancelButtonText: "Não!",
                })
                .then((result) => {
                    if (!result.value) return;
                    this.products_v3_service
                        .destroy(product.pro_id)
                        .then(() => {
                            this.loadProducts();
                            this.$swal.fire("Excluído!", "Produto excluído com sucesso.", "success");
                        })
                        .catch((error) => {
                            ErrorHandlerService.handle(error, this.$store);
                        });
                });
        },
        handleOtherFunction({ key }) {
            if (key === "print") this.confirmPrint();
            else if (key === "excel") this.confirmExcel();
            else if (key === "groups") this.showManagementProducts = true;
            else if (key === "categories") this.showCategories = true;
            else if (key === "import") this.importVf();
        },
        confirmPrint() {
            this.$swal
                .fire({
                    icon: "info",
                    title: "Impressão de relatório",
                    text: "Deseja imprimir o relatório selecionado?",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Imprimir",
                })
                .then((resp) => {
                    if (resp.isConfirmed) this.printProductsList();
                });
        },
        confirmExcel() {
            this.$swal
                .fire({
                    icon: "info",
                    title: "Gerar Excel",
                    text: "Deseja gerar um relatorio em Excel?",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Gerar Excel",
                })
                .then((resp) => {
                    if (resp.isConfirmed) this.exportExcel();
                });
        },
        fetchExportProducts() {
            return this.products_v3_service
                .query({ ...this.buildFilterParams(), per_page: EXPORT_PAGE_SIZE, sort: this.buildSort() })
                .then(({ data }) => data.data || []);
        },
        exportExcel() {
            this.loadingFull = true;
            this.fetchExportProducts()
                .then((produtos) => {
                    const rows = produtos.map((product) => {
                        const embalagem = String(product.pro_embalagem || "").split(" ");
                        return [
                            product.pro_ean,
                            product.pro_descricao,
                            product.pro_generico == 1 ? product.pro_unidade_compra : embalagem[0],
                            product.pro_generico == 1 ? " " : embalagem[1],
                            " ",
                            " ",
                            " ",
                            " ",
                            product.cat_descricao,
                        ];
                    });
                    new MyProductsExcelDownload(rows);
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loadingFull = false;
                });
        },
        printProductsList() {
            this.loadingFull = true;
            this.fetchExportProducts()
                .then((produtos) => {
                    this.printProducts = produtos;
                    this.printDate = moment().format("DD/MM/YYYY  HH:mm:ss");
                    this.$nextTick(this.openPrintFrame);
                })
                .catch((error) => {
                    this.loadingFull = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        openPrintFrame() {
            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.bottom = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "none";

            const content = document.getElementById("products-v2-print").innerHTML;
            const html =
                "<html><head>" +
                '<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700">' +
                "<title></title><style>" +
                ".logo {width: 10rem;}" +
                ".table{margin-top: 4vh; border: 1px solid gray}" +
                ".print-table-row{ display: flex; font-size: 1.3vw; text-transform: lowercase; padding-left: 1vw; }" +
                ".print-table-desc{flex: 1}" +
                ".print-table-ean{flex: 1}" +
                ".print-table-eamb{width: 16%}" +
                ".print-table-cat{width: 16%}" +
                ".print-table-est{width: 8%}" +
                "</style></head><body>" +
                content +
                "</body></html>";

            document.body.appendChild(iframe);
            const doc = iframe.contentDocument || iframe.contentWindow.document;
            doc.open();
            doc.write(html);
            doc.close();
            iframe.onload = () => {
                try {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                } catch (e) {
                    const printWindow = window.open("", "_blank");
                    printWindow.document.write(html);
                    printWindow.document.close();
                    setTimeout(() => printWindow.print(), 500);
                }
                setTimeout(() => {
                    document.body.removeChild(iframe);
                    this.loadingFull = false;
                }, 1000);
            };
        },
        importVf() {
            const lastSync = this.setting("LAST_VAREJO_FACIL_SYNC_DATE");
            this.confirm_action({
                message: "Confirma importação da base de produtos do Varejo Facil?",
                subtitle: lastSync
                    ? `Sua última importação foi finalizada no dia ${moment(lastSync.value).format("DD/MM/YY HH:mm")}. Apenas produtos criados apartir dessa data serão importados`
                    : "Você ainda realizou nenhuma importação de produtos do Varejo Facil ou sua importação está em andamento",
                callback: () => {
                    this.loader_msg("Iniciando agendamento de importação de produtos Varejo Facil...");
                    this.vf_svc
                        .import_products()
                        .then(() => {
                            this.dismiss_loader();
                            this.$store.dispatch("user/reload_user");
                        })
                        .catch(() => {
                            this.dismiss_loader();
                            this.present_info(
                                "Ocorreu um erro durante a importação. É possível que a equipe responsável tenha sido notificada."
                            );
                        });
                },
            });
        },
        loadCategories() {
            const config = { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } };
            axios.get(`${CONSTANTS.API_URL}/listarcategoriascliente`, config).then(({ data }) => {
                this.arrayCategoria = data.categorias || [];
            });
        },
        loadGroups() {
            this.groupService.loadProductGroups().then(({ data }) => {
                this.groups = Array.isArray(data) ? data : [];
            });
        },
        handleResize() {
            this.isDesktop = window.innerWidth >= 720;
        },
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
        this.loadProducts(1);
        this.loadCategories();
        this.loadGroups();
        this.$store.dispatch("user/reload_user");
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_list-page-v2";

.expanded-content {
    padding: 4px 0 8px 0;
}
</style>
